import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FullDate } from '../../../../components/Date/FullDate'
import { CustomBtn } from '../../../../components/button/button'
import { Input } from '../../../../components/input/input'
import { Main } from '../../../../constant'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import CustomTable from '../../../../components/table/SimpleTable'
import { ShowLoader } from '../../../../redux/actions/loader'

function EnrollStudent(studentDetails) {
    // //console.log(studentDetails)
    const [data, setData] = useState(Main().Fee);
    const [getfilterdata, setGetfilterdata] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
    const [initialInputValues, setInitialInputValues] = useState(Object.fromEntries(
      getfilterdata
        .map((item) => [item.name, ''])
    ));
    const [inputValues, setInputValues] = useState({ Date: dayjs().format('MMMM YYYY'), ...initialInputValues });
    const [amount, setAmount] = useState('');
    const [feesPay, setFeesPay] = useState('');
    const [comments, setComments] = useState('');
    
  const dispatch = useDispatch();
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const url = useSelector((state) => state.Api);
  const [recordInserted, setRecordInserted] = useState(false);
  const [feesForMonth, setFeesFormMonth] = useState(0);
  const [numberOfDays, setNumberOfDays] = useState(0);
  const [feesForNumberOfDays, setFeesForNumberOfDays] = useState(0);
  const showlatefee = useSelector((state) => state.Api.showlatefee);
  const [dues, setDues] = useState(0);     
  const [enrolmentDone, setEnrolmentDone] = useState(false) 
  const calculateFees = () => {
    const timestamp = window.Date.now(); // You can also just use Date.now()
    const currentDate = dayjs(timestamp); // Use dayjs to get the current date
    let feesForDays = 0;
    const daysInCurrentMonth = currentDate.daysInMonth();

    if (inputValues.DateFrom) { // Check if DateFrom is falsy (undefined or empty)
      const startDate = parseInt(inputValues.DateFrom.split('-')[2], 10);
      const remainingDays = daysInCurrentMonth - (startDate - 1);
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      setNumberOfDays(remainingDays);
    } else {
      const remainingDays = daysInCurrentMonth - currentDate.date();
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      // If you need to set the number of days for the current date, uncomment the line below
      setNumberOfDays(remainingDays);
    }

    // Ensure you're only setting state when necessary to avoid loops
    setFeesForNumberOfDays(feesForDays.toFixed(2));
    setFeesFormMonth(currentDate.month() + 1);

  }

  useEffect(() => {
    // console.log('enrollment csom')
    calculateFees()
  }, [amount, inputValues, dues, feesPay])

  const ChangeDate = (e) => {
    // //console.log(`${e.$y}-${e.$M}-${e.$D}`)
    //console.log(`${e.$y}-${e.$M + 1}-${e.$D}`)
    setInputValues((prevValues) => ({
      ...prevValues,
      DateFrom: `${e.$y}-${e.$M + 1}-${e.$D}`,
    }));
    calculateFees()
  }
  function enrollStudentFunc(e) {
    e.preventDefault();

    const timestamp = window.Date.now(); // You can also just use Date.now()
    const currentDate = dayjs(timestamp); // Use dayjs to get the current date
    let fetchTodayDate = inputValues.DateFrom
    if (!inputValues.DateFrom) { // Check if DateFrom is falsy (undefined or empty)
      const formattedDate = `${currentDate.year()}-${currentDate.month() + 1}-${currentDate.date()}`;
      fetchTodayDate = formattedDate
    }
    const Month = fetchTodayDate.split('-')[1]
    const monthName = new Date(2025, Month - 1).toLocaleString('en-US', { month: 'long' });
 
    const payload = {
      RollNum: studentDetails?.studentDetails?.StudentDetails?.RollNum, Fees: amount, Comments: comments,
      DateFrom: fetchTodayDate, Month:monthName, NumberOfDays: numberOfDays, CurrentMonthFees: feesForNumberOfDays
    }
    //console.log(payload)
    // return false
    try {
      dispatch(ShowLoader('1'))
      axios.post(url.transportEnroll, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            // console.log(res.data.message);
            // setSuggestions(res.data.message);
            setEnrolmentDone(true)
            setRecordInserted(true)
            setFeesForNumberOfDays(0)
            dispatch(ShowLoader('0'))
          }
        })
        .catch((err) => {
          //console.error(err); // Log the error response for debugging
          dispatch(ShowLoader('0'))
        });
    } catch (err) {
      dispatch(ShowLoader('0'))
      //console.error(err);
    }
  }
    return (
        <>
        {studentDetails?.studentDetails?.status?.TransportFacility == 'No' && !enrolmentDone?
          <form onSubmit={enrollStudentFunc}>

          <Grid>

              <FullDate throwfullevent={ChangeDate} name='startDate' />
              <Input
                  onChange={(event) => setAmount(event.target.value)}
                  name="Amount" value={amount} placeholder='Monthly Fees' />

              <br />
              <Typography sx={{ color: 'red' }} variant='b'>
                  Current Month Fees: {feesForNumberOfDays}
              </Typography> 
              <br/>
              <textarea sx={{ margin: '15px 0px 0px' }} rows="4" cols="74" onChange={(event) => setComments(event.target.value)} name="comments" placeholder='Comments' ></textarea>

              {/* <br/>{amount == ''? 'true' : 'false'} */}
              <CustomBtn disabled={amount == ''} data='Enroll' />

          </Grid>
      </form>
        :
        studentDetails?.studentDetails?.StudentDetails?.RollNum?
        <Grid> {`${studentDetails?.studentDetails?.StudentDetails?.RollNum}  ${studentDetails?.studentDetails?.StudentDetails?.Name_P} Already Enrolled`}  </Grid>  
                  
        : 
        <Grid>Please Select Student</Grid>
        }

        </>
    )
}

export default EnrollStudent
